module.exports = __webpack_public_path__ + "static/media/icon-score-2-scale-4.a2bf0d6a.svg";